export default __webpack_public_path__ + "static/media/logoMVCLight.1e6d2bce.png";